import React from "react";
var __jsx = React.createElement;
import AsideTag from "./AsideTag/AsideTag";
import stl from "./AsideTags.module.css";
import { CDN_LINK } from "@globalConfig";
import useFirstRender from "../../../../../../common/hooks/useFirstRender";
import useIsMobile from "@hooks/useIsMobile";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
function AsideTags(_ref) {
  var selectedOptions = _ref.selectedOptions,
    handleDeleteFilters = _ref.handleDeleteFilters,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? "" : _ref$className,
    id = _ref.id,
    loading = _ref.loading,
    showAllTags = _ref.showAllTags,
    setShowAllTags = _ref.setShowAllTags,
    setTempSelectedOptions = _ref.setTempSelectedOptions;
  var isFirstRender = useFirstRender();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var isMobile = useIsMobile();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    id: id ? id : "AsideHeight2",
    className: [stl.container, showAllTags ? stl.showAllTage : "", className].join(" ")
  }, loading && !isFirstRender && isMobile && /*#__PURE__*/React.createElement("div", {
    className: stl.loadingDiv
  }, /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/FilterLoader.svg",
    alt: "loading"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.mobWrapper
  }, selectedOptions.length > 0 && /*#__PURE__*/React.createElement(AsideTag, {
    id: "filter-tags-reset-btn",
    onClick: function onClick() {
      setTempSelectedOptions([]);
      navigateTo("/filters");
    },
    isActiveDiscount: false,
    name: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/restart.svg",
      alt: "restart button",
      "aria-label": "restart button"
    }), /*#__PURE__*/React.createElement("span", null, t("reset", {
      ns: "web_search"
    }))),
    hideDelete: true,
    className: "".concat(stl.reset, " m-show")
  }), selectedOptions.map(function (option, i) {
    var rangeFilters = ["year", "odometer", "sellingprice", "monthly_installment"];
    var isRangeFilter = rangeFilters.includes(option === null || option === void 0 ? void 0 : option.filterField);
    if (isRangeFilter) {
      return /*#__PURE__*/React.createElement(AsideTag, {
        key: i,
        id: "filter-tag-".concat(option === null || option === void 0 ? void 0 : option.filterField),
        onClick: function onClick() {
          return handleDeleteFilters(option);
        },
        isDicountTag: false,
        isActiveDiscount: false,
        name: "".concat(option.range_values.from, " - ").concat(option.range_values.to, " ").concat(option.range_values.unit),
        hideDelete: false,
        loading: false
      });
    }
    return /*#__PURE__*/React.createElement(AsideTag, {
      key: i,
      id: "filter-tag-".concat(option === null || option === void 0 ? void 0 : option.filterField, "-").concat(option === null || option === void 0 ? void 0 : option.id),
      onClick: function onClick() {
        return handleDeleteFilters(option);
      },
      isDicountTag: false,
      isActiveDiscount: false,
      name: option.name,
      hideDelete: false,
      loading: false
    });
  }), selectedOptions.length > 5 && /*#__PURE__*/React.createElement(AsideTag, {
    id: "filter-tags-toggle-btn",
    className: [stl.toggleTag, "m-hide"].join(" "),
    onClick: function onClick() {
      setShowAllTags(!showAllTags);
    },
    isDicountTag: false,
    iconImage: !showAllTags ? CDN_LINK + "/assets/images/plusM.svg" : CDN_LINK + "/assets/images/minusM.svg",
    name: /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, !showAllTags ? t("show", {
      ns: "web_search"
    }) : t("show_less", {
      ns: "web_search"
    })), " ", /*#__PURE__*/React.createElement("span", null, !showAllTags && "(" + (selectedOptions.length - 4) + ")"))
  }))));
}
export default AsideTags;